import { AxiosRequestConfig } from 'axios'
import { IQuest } from '../server/quests'

const postArticleQuest = (id: string, data : IQuest  ): AxiosRequestConfig => ({
    url: `/tasks/quest`,
    method: 'POST',
    data: {
        id,
        data
    }
})

export { postArticleQuest }
